import React, { useEffect } from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import "react-tooltip/dist/react-tooltip.css";
import { SimulationProvider } from "./ai-gone-rogue/SimulationContext";
import AntarcticaView from "./antarctica/AntarcticaView";
import { AntarcticaProvider } from "./antarctica/context/AntarcticaContext";
import AthenaGame from "./athena/AthenaGame";
import SimulationView from "./components/SimulationView";
import { ThemeProvider } from "./context/ThemeContext";
import SimulationEditor from "./dark-money/components/editor/SimulationEditor";
import { DarkMoneyProvider } from "./dark-money/context/SimulationContext";
import MainContainer from "./dark-money/layout/MainContainer";
import LandingPage from "./home/LandingPage";
import PricingCalculator from "./home/PricingCalculator";
import PricingSummary from "./home/PricingSummary";
import { OperationAresProvider } from "./operation-ares/context/OperationAresContext";
import OperationAres from "./operation-ares/OperationAres";

function App() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const userUuid = params.get("userUuid");
    if (userUuid) {
      console.log("User UUID from URL:", userUuid);
    }
  }, []);

  return (
    <ThemeProvider>
      <DarkMoneyProvider>
        <Router>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route
              path="/ai-gone-rogue"
              element={
                <SimulationProvider>
                  <SimulationView />
                </SimulationProvider>
              }
            />
            <Route
              path="/antarctica"
              element={
                <AntarcticaProvider>
                  <AntarcticaView />
                </AntarcticaProvider>
              }
            />
            <Route
              path="/operation-ares"
              element={
                <OperationAresProvider>
                  <OperationAres />
                </OperationAresProvider>
              }
            />
            <Route path="/dark-money" element={<MainContainer />} />
            <Route path="/dark-money/editor" element={<SimulationEditor />} />
            <Route path="/pricing-calculator" element={<PricingCalculator />} />
            <Route path="/summary/:type" element={<PricingSummary />} />
            <Route path="/athena" element={<AthenaGame />} />
          </Routes>
        </Router>
      </DarkMoneyProvider>
    </ThemeProvider>
  );
}

export default App;
